import { siteNav } from "@/mocks/critter";

const socials = [
  { icon: "ri-wechat-fill", label: "微信公众号" },
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
  { icon: "ri-linkedin-fill", label: "LinkedIn" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          {/* brand */}
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-400 text-foreground-950">
                <i className="ri-megaphone-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black text-background-50">
                呱呱<span className="text-accent-400">爆料</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-secondary-200">
              独立思考、证据优先、讲清利益背后的逻辑。用看得懂的方式，拆解行业黑幕与圈内潜规则。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {socials.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  aria-label={s.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-secondary-800 text-secondary-200 transition-colors hover:bg-accent-500 hover:text-foreground-950 whitespace-nowrap"
                >
                  <i className={`${s.icon}`}></i>
                </button>
              ))}
            </div>
          </div>

          {/* nav */}
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.2em] text-accent-300">快速导航</p>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
              {siteNav.slice(1).map((n) => (
                <li key={n.id}>
                  <a href={n.href} className="inline-block text-sm text-secondary-200 hover:text-accent-300 whitespace-nowrap">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* note */}
          <div className="lg:col-span-1">
            <p className="font-label text-[11px] uppercase tracking-[0.2em] text-accent-300">阅读须知</p>
            <ul className="mt-4 space-y-2.5 text-sm leading-relaxed text-secondary-200">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-400"></i>
                观点供参考，不构成投资或决策建议
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-accent-400"></i>
                内容基于公开资料，避免针对个人的主观攻击
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-heart-line mt-0.5 text-accent-400"></i>
                涉及真实主体仅做中性分析与提示
              </li>
            </ul>
          </div>

          {/* contact */}
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.2em] text-accent-300">联系方式</p>
            <ul className="mt-4 space-y-2.5 text-sm text-secondary-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                contact@guaguabaoliao.example
              </li>
              <li>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-foreground-950 hover:bg-accent-400 transition-colors whitespace-nowrap"
                >
                  投递线索 <i className="ri-send-plane-line"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-800 pt-6 sm:flex-row">
          <p className="text-xs text-secondary-300">
            © {year} 呱呱爆料 · 保留所有权利。让信息更透明，让选择更清醒。
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-secondary-300">
            <a href="#about" className="hover:text-accent-300 whitespace-nowrap">关于我们</a>
            <a href="#faq" className="hover:text-accent-300 whitespace-nowrap">常见疑问</a>
            <a href="#contact" className="hover:text-accent-300 whitespace-nowrap">联系与合作</a>
          </div>
        </div>
      </div>
    </footer>
  );
}